module.exports = __webpack_public_path__ + "c4f87be5e2b96e708fc4a1360ec2641e.png";